import type IMfaRepository from '../IMfaRepository';
import type { MfaVerifyResponse } from '../mfa.types';
import { injectable } from 'inversify';
import API from '@repositories/Axios';

/**
 * MFA Repository Implementation
 */
@injectable()
export class MfaRepository implements IMfaRepository {
  /**
   * MFA 인증/설정 검증
   * POST /actions/verify-mfa
   *
   * @param otpCode - 6자리 OTP 코드
   * @returns MFA 인증 검증 결과 { verified, remainingAttempts, user? }
   */
  async verifyMfa(otpCode: string): Promise<MfaVerifyResponse> {
    const response = await API.post<MfaVerifyResponse>('/api/v1/actions/verify-mfa', {
      otpCode,
    });

    return response.data;
  }

  async updateUserMfa(userId: string): Promise<void> {
    await API.post<void>(`/api/v1/actions/reset-mfa`, {
      userId,
    });
  }
  async updateMyMfa(password: string): Promise<void> {
    await API.post<void>(`/api/v1/actions/reset-my-mfa`, {
      password,
    });
  }
}
